import { createSlice } from '@reduxjs/toolkit';

type stateType = {
  currentPosition: string;
  isMobileWidth: boolean;
};

export const initialState: stateType = {
  currentPosition: 'Home',
  isMobileWidth: false,
};

export const ulSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setUiValue: (state, action) => {
      state.currentPosition = action.payload;
    },
    setIsMobile: (state, action) => {
      state.isMobileWidth = action.payload;
    },
  },
});
export const { setUiValue, setIsMobile } = ulSlice.actions;

export default ulSlice.reducer;
